import { render, staticRenderFns } from "./submitted.vue?vue&type=template&id=9e48af94&"
import script from "./submitted.vue?vue&type=script&lang=js&"
export * from "./submitted.vue?vue&type=script&lang=js&"
import style0 from "./submitted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports